// Perguntas frequentes. As respostas são informativas e não substituem
// a análise individual de cada caso — mantenha esse tom ao editar.

const faq = [
  {
    id: 'flagrante',
    pergunta: 'Um familiar foi preso em flagrante. O que devo fazer agora?',
    resposta:
      'Entre em contato com um advogado imediatamente e anote o máximo de informações: nome completo, delegacia onde a pessoa está, número do boletim de ocorrência e horário da prisão. As primeiras horas são decisivas, porque é nesse período que ocorrem o interrogatório e a audiência de custódia, que deve acontecer em até 24 horas. Evite que o preso preste depoimento sem acompanhamento de defensor.',
  },
  {
    id: 'delegacia',
    pergunta: 'Preciso de advogado já no depoimento na delegacia?',
    resposta:
      'A presença do advogado desde a fase de inquérito é altamente recomendável. É nesse momento que a prova começa a ser construída, e declarações prestadas sem orientação técnica podem acompanhar o investigado por todo o processo. O advogado tem direito de acesso aos autos e de acompanhar o ato.',
  },
  {
    id: 'silencio',
    pergunta: 'Recebi uma intimação para depor. Sou obrigado a falar?',
    resposta:
      'O direito ao silêncio é garantido pelo art. 5º, LXIII, da Constituição Federal, e o seu exercício não pode ser interpretado em prejuízo de quem é investigado ou acusado. Comparecer quando intimado, porém, costuma ser obrigatório. O que se deve ou não responder é uma decisão estratégica, tomada com o advogado antes do ato.',
  },
  {
    id: 'custodia',
    pergunta: 'O que é a audiência de custódia?',
    resposta:
      'É a apresentação do preso a um juiz em até 24 horas após a prisão em flagrante. Nela, verifica-se a legalidade da prisão e a eventual ocorrência de maus-tratos, e decide-se entre a conversão em prisão preventiva, a concessão de liberdade provisória — com ou sem medidas cautelares — ou o relaxamento da prisão.',
  },
  {
    id: 'inquerito',
    pergunta: 'Fui indiciado em um inquérito. Já sou réu?',
    resposta:
      'Não. O indiciamento é um ato da autoridade policial que aponta alguém como provável autor de uma infração. A condição de réu só surge quando o Ministério Público oferece denúncia e o juiz a recebe. A atuação da defesa ainda na fase de inquérito pode influenciar diretamente essa etapa.',
  },
  {
    id: 'liberdade',
    pergunta: 'É possível responder ao processo em liberdade?',
    resposta:
      'A regra no processo penal brasileiro é a liberdade; a prisão antes do trânsito em julgado é excepcional e exige fundamentação concreta. Cabe à defesa demonstrar a ausência dos requisitos da prisão preventiva ou apresentar medidas cautelares alternativas. Cada caso é analisado individualmente, a partir das circunstâncias concretas.',
  },
  {
    id: 'honorarios',
    pergunta: 'Como funcionam os honorários?',
    resposta:
      'Os honorários são definidos caso a caso, conforme a complexidade da matéria, a fase do procedimento, o local de atuação e o tempo estimado de trabalho, sempre observada a Tabela de Honorários da OAB. Tudo é apresentado por escrito, com valores e formas de pagamento, antes de qualquer contratação.',
  },
  {
    id: 'sigilo',
    pergunta: 'As informações que eu passar ficam em sigilo?',
    resposta:
      'Sim. O sigilo profissional é dever do advogado, previsto no Estatuto da Advocacia e no Código de Ética e Disciplina da OAB, e alcança inclusive a consulta que não resulta em contratação.',
  },
];

export default faq;
